<div *ngIf="alertService.alertBanner.isAgent">
  <app-alert-banner [showClose]="alertService.showCloseIcon" [alerts]="alertService.alertBanner.agentNotification" position="fixed" placement="top"
    [edgeOffset]="0" [insetLeft]="350" [insetRight]="350" [zIndex]="40" (closed)="alertService.alertBanner.isAgent = false"
    (actionClicked)="onAction($event)"></app-alert-banner>
</div>
<header class="header-fixed">
  <!--FleCX Header Section -->
  <div class="mast-header">
    <div class="main-menu-wrapper">
      <nav class="main-nav-container">
        <ul class="main-nav">
          <li *ngFor="let nav of navService.topNavs">
            <a [attr.data-interaction]="nav.name + ' tab'" *ngIf="nav.show" [routerLink]="nav.url" [ngClass]="
            nav.active ? 'main-nav__links main-nav__links--active' : 'main-nav__links'
              ">
              <span [attr.data-interaction]="nav.name + ' tab'">{{ nav.name }}</span>
            </a>
          </li>
        </ul>
      </nav>
    </div>
    <div class="details-wrapper">

      @if(isIbexProvider) {
      @if(insightVoiceConfig) {
      <div class="connectivity-monitor-container">
        <a [attr.data-tooltip]="insightVoiceConfig.tooltip" data-tooltip-conf="bottom shadow"
          class="connectivity-monitor {{ insightVoiceConfig.class }}">
          <i class="connectivity__icon">
            <img [src]="insightVoiceConfig.icon" />
          </i>
          @if (insightVoiceConfig.badge) {
          <span class="connectivity__badge">
            <img [src]="insightVoiceConfig.badge" />
          </span>
          }
        </a>
      </div>
      }

      <div class="connectivity-monitor-container">
        @if (voiceStatusConfig) {
        <a [attr.data-tooltip]="voiceStatusConfig.tooltip" data-tooltip-conf="bottom shadow"
          class="connectivity-monitor {{ voiceStatusConfig.class }}" (click)="voiceStatusConfig.click?.()">
          <i class="connectivity__icon">
            <img [src]="voiceStatusConfig.icon" />
          </i>
          @if (voiceStatusConfig.badge) {
          <span class="connectivity__badge">
            <img [src]="voiceStatusConfig.badge" />
          </span>
          }
        </a>
        }

      </div>
      }
    
       <ng-container *ngIf="navService.isBusinessHoursIcon && OutboundBusinessHours.length">
      <div class="notification-monitor-container" *ngxPermissionsOnly="['insights_dashboard_outboundDialerSetting']">
        <a [fTooltip]="tooltipContent" tooltipPosition="bottom" class="notification-monitor mr-10">
          <i class="notification__icon fa-light fa-business-time"></i>
        </a>
        <ng-template #tooltipContent>
          <div class="business-tooltip">
            <div class="tooltip-title">
              <span class="icon">🕒</span>
              <span>Business Hours (EST)</span>
            </div>
            @for (item of OutboundBusinessHours; track item.code) {
            <div class="tooltip-row" [class.closed]="!item.isBusinessDay">
              <div class="country-info">
                <img class="flag" [src]="item.flag" [alt]="item.code" width="20" height="15" />
                <span class="country-code">{{ item.code }}</span>
              </div>
              <div class="time">
                <span class="pause-badge" [class.hidden]="!item.isPause">
                  Pause
                </span>
                <span class="hours">
                  {{ item.hours }}
                </span>
              </div>
            </div>
            }
          </div>
        </ng-template>
      </div>
       </ng-container> 
      <div class="notification-monitor-container">
        <a data-tooltip="Realtime Events" data-tooltip-conf="bottom shadow" class="notification-monitor mr-10">
          <i class="notification__icon fa-light" [ngClass]="isSignalRConnected() ? 'fa-signal' : 'fa-signal-slash'"></i>
        </a>
      </div>

      <div class="notification-monitor-container">
        <!-- <div [attr.data-tooltip]="getInternetStatusText()" data-tooltip-conf="bottom shadow multiline"
          class="notification-monitor mr-10 icon-merge">
          <i class="notification__icon fa-light fa-tower-cell icon-override"
            [ngClass]="internetState ? 'internet-on' : 'internet-off'"></i>
          <i class="notification__icon fa-light fa-tower-cell"
            [ngClass]="isSignalRConnected() ? 'signalR-on' : 'signalR-off'"></i>
        </div> -->
        <!-- <a  [attr.data-tooltip]="getSignalRState()" data-tooltip-conf="bottom shadow"
          class="notification-monitor mr-10">
          <i class="notification__icon fa-light "
            [ngClass]="isSignalRConnected() ? 'fa-signal-bars' : 'fa-signal-slash'"></i>
        </a> -->
        <a (click)="navService.toggleBugReportPane()" data-tooltip="Feedback" data-tooltip-conf="bottom shadow"
          class="notification-monitor mr-10">
          <i class="notification__icon fa-light fa-lightbulb-on flecx_feedback_icon"></i>
        </a>
      </div>
      <div class="notification-monitor-container">
        <a (click)="navService.toggleNotificationPane()" data-tooltip="Notifications" data-tooltip-conf="bottom shadow"
          class="notification-monitor notification-monitor--with-badge"><i
            class="notification__icon fa-light fa-bell flecx_notification_icon"></i>
          <span (click)="navService.toggleNotificationPane()" class="notification__badge"
            *ngIf="(notificationsService.getUnreadNotificationCount() | async) as unreadCound">
            {{ unreadCound }}
          </span></a>
      </div>
      <div class="notification-monitor-container" *ngIf="alertService.showBannerIcon">
        <a (click)="alertService.toggleAlertBanner()" data-tooltip="Alerts" data-tooltip-conf="bottom shadow"
          class="notification-monitor notification-monitor--with-badge"><i
            class="notification__icon fa-light fa-triangle-exclamation flecx_notification_icon"></i>
          <span (click)="alertService.toggleAlertBanner()" class="notification__badge"
            *ngIf="alertService.getAlertCount()">
            {{ alertService.getAlertCount() }}
          </span></a>
      </div>
      <div class="notification-monitor-container" *ngIf="isAgent">
        <a (click)="navService.toggleRequestPane()" data-tooltip="Requests" data-tooltip-conf="bottom shadow"
          class="notification-monitor notification-monitor--with-badge"><i
            class="notification__icon fa-light fa-comment flecx_notification_icon"></i>
          <span (click)="navService.toggleNotificationPane()" class="notification__badge"
            *ngIf="conversationService.requests && conversationService.requests.length > 0">
            {{ conversationService.requests.length }}
          </span>
        </a>
      </div>
      <div class="profile-module-container">
        <div class="profile-module" [attr.data-interaction]="'profile dropdown menu click'">
          <div (clickOutside)="onClickOutSideOfProfileContext($event)">
            <div [attr.data-interaction]="'profile dropdown menu click'" class="profile-module__picture">
              <img [attr.data-interaction]="'profile dropdown menu click'" [src]="authService.authData.ProfilePic"
                alt="" />
            </div>
            <div [attr.data-interaction]="'profile dropdown menu click'" (click)="handleProfileDropdown()"
              class="profile-module__name profile-module__options-trigger" data-toggle="profileOptions">
              <span [attr.data-interaction]="'profile dropdown menu click'">
                {{ this.currentUser.FirstName ?? '----' }}
              </span>
            </div>
          </div>
          <!-- Remove "hide" class to show options-list -->
          <div class="profile-module__options-list" [ngClass]="navService.getProfileContext() ? '' : 'hide'">
            <ul>
              <li>
                <!-- Logged In User -->
                <div class="logged-in-user">
                  <div class="logged-in-user__bg-shade"></div>
                  <div class="logged-in-user__avatar">
                    <!-- User Avatar -->
                    <div class="user-avatar user-avatar--lg">
                      <span class="user-avatar__img">{{ shortName }}</span>
                      <i class="user-avatar__status-icon user-avatar__status-icon--primary"></i>
                    </div>
                  </div>
                  <div class="logged-in-user__info">
                    <h5>{{ this.currentUser.FirstName }} {{this.currentUser.LastName}}</h5>
                    <p>{{ this.currentUser.Email }}</p>
                  </div>
                </div>
              </li>
              <ng-container *ngIf="!telephonyState.onCall && telephonyState.isCallEnded">
                <li *ngxPermissionsOnly="['agent_dashboard_myAccount', 'insights_dashboard_myAccount']"
                  (click)="onNavigateToMyAccount($event)">
                  <a class="border"><i class="fa-light fa-circle-user"></i><span>My
                      Account</span></a>
                </li>
                <!-- <li>
                  <a ><i class="fa-light fa-bug"></i><span>Bug Report</span></a>
                </li> -->
                <li [ngClass]="{'disabled' : disableLogout }" (click)="onLogout($event)">
                  <a class="border"><i class="fa-light fa-right-from-bracket"></i><span>Logout</span></a>
                </li>
              </ng-container>
            </ul>
          </div> 
            <ng-container *ngxPermissionsOnly="['agent_dashboard_status']">
              <div *ngIf="this.showTopBarData" class="current-status-container">
                <div (clickOutside)="onClickOutSideOfCallContext($event)" data-toggle="current-status__status-list"
                  [className]="'current-status ' + statusService.currentStatus.class">
                  <div [attr.data-interaction]="'status menu dropdown'"
                    (click)="navService.setCallContext(!navService.getCallContext())" [className]="'current-status__icon ' + statusService.currentStatus.bgclass">
                    <i [attr.data-interaction]="'status menu dropdown'" class="fa-regular fa-angle-down"></i>
                  </div>
                  <div class="current-status__value">
                    <span>
                      <ng-container *ngIf="statusService.loading"><i class="please-wait"><i
                            class="fa fa-spinner fa-spin fa-fw"></i>Connecting...</i></ng-container>
                      <ng-container *ngIf="!statusService.loading">{{ statusService.currentStatus.Name}}</ng-container>
                    </span>
                  </div>
                  <!-- Remove "hide" class to show options-list -->
                  <div class="current-status__status-list" [ngClass]="navService.getCallContext() ? '' : 'hide'">
                    <ul>
                      <ng-container *ngFor="let status of statusService.statuses">
                        <ng-container *ngxPermissionsOnly="[status.Permission]">
                          <li [attr.data-interaction]="status.Name + 'status select'" *ngIf="showHideStatus(status.FriendlyName)"
                            (click)="changeStatus(status.FriendlyName)">
                            <a [attr.data-interaction]="status.Name + 'status select'"
                              [ngClass]="{'active' : statusService.checkStatus(status.FriendlyName)}">
                              <i [attr.data-interaction]="status.Name + 'status select'" [ngClass]="status.Icon"></i>
                              <span [attr.data-interaction]="status.Name + 'status select'">{{status.Name}}</span>
                            </a>
                          </li>
                        </ng-container>
                      </ng-container>
                    </ul>
                  </div>
                </div>
              </div>
            </ng-container>
        </div>
      </div> 
    </div>
  </div>
  <!-- Secondary Nav/Top/Bar/Action Bar -->
  <div class="top-bar">
    <ng-container *ngIf="router.isActive('/supervisor/insight/dashboard', true); else heading;">
      <tabs [data]="navService.tabs" [withWrapper]="false" [isSubNav]="true"
        (getSelectedTab)="navService.getSelectedTab($event)" [title]="navService.getTitle()"></tabs>
    </ng-container>
    <ng-template #heading>
      <div class="page-heading">
        <h1>{{ navService.getTitle() }}</h1>
      </div>
    </ng-template>
    <ng-container *ngIf="navService.isCenterLocation && (isQA || isSupervisor || isAdmin) && !(callMonitorService.isMonitoring &&
      router.url === '/supervisor/insight/call-monitor')">
      <tabs [data]="centerViewTabs" [withWrapper]="false" [isSubNav]="true" [tabSubNavClasses]="'sub-nav--centered'" (getSelectedTab)="centerViewTab($event)">
      </tabs>
    </ng-container>
    <div class="page-actions">
      @if(isConnectHub) {
          <app-today-scheduled-callbacks *ngxPermissionsOnly="['agent_calls_callBack']"> </app-today-scheduled-callbacks>
      }
      <div *ngIf="this.showTopBarData" class="chips-container">
        <div class="chips chips--with-divider timer" *ngxPermissionsOnly="['agent']">
          <i class="fa-light fa-user chips__icon"></i>
          <span class="chips__value" data-tooltip="Login Time" data-tooltip-conf="bottom shadow">{{
            authService.loginDuration }}</span>
        </div>
        <div class="chips chips--with-divider timer" *ngxPermissionsOnly="['agent']">
          <i class="fa-light fa-clock-eight chips__icon"></i>
          <span class="chips__value" data-tooltip="Status Time"
            data-tooltip-conf="bottom shadow">{{statusService.duration}}</span>
        </div>
        <!-- *ngIf="telephonyState.onCall && !telephonyState.isCallEnded" -->
        <ng-container>
          <div class="chips chips--with-divider" data-tooltip="Customer" data-tooltip-conf="bottom shadow no-arrow">
            <span class="has-call-connectivity">
              <i class="fa-solid fa-user-vneck-hair"></i>
              <span
                [ngClass]="{'call-connectivity' : telephonyState.isCustomerConnected && telephonyState.onCall && !telephonyState.isCallEnded}"
                class="--one"></span>
            </span>
          </div>
          <div class="chips chips--with-divider" data-tooltip="Agent" data-tooltip-conf="bottom shadow no-arrow">
            <i class="fa-solid fa-user-headset green"></i>
          </div>
          <div class="chips chips--with-divider" data-tooltip="Third Party" data-tooltip-conf="bottom shadow no-arrow">
            <span class="has-call-connectivity">
              <i class="fa-light fa-user-tie"></i>
              <span
                [ngClass]="{'call-connectivity' : telephonyState.isThirdPartyConnected && telephonyState.onCall && !telephonyState.isCallEnded}"
                class="--two"></span>
            </span>
          </div>
        </ng-container>
  
        <!-- *ngIf="showDialpadIcon()" -->
        <div class="chips chips--with-divider" *ngIf="showDialpadIcon()"
          (click)="navService.setSideNav(!navService.getSideNav('right'), 'right')">
          <i class="fa-regular chips__icon">
            <svg width="16" height="17" viewBox="0 0 16 17" fill="#fff" xmlns="http://www.w3.org/2000/svg">
              <rect x="0.420898" y="0.84375" width="4" height="4" rx="2" />
              <rect x="0.420898" y="6.65625" width="4" height="4" rx="2" />
              <rect x="6.0791" y="0.84375" width="4" height="4" rx="2" />
              <rect x="6.0791" y="6.65625" width="4" height="4" rx="2" />
              <rect x="6.0791" y="12.1562" width="4" height="4" rx="2" />
              <rect x="11.5791" y="0.84375" width="4" height="4" rx="2" />
              <rect x="11.5791" y="6.65625" width="4" height="4" rx="2" />
            </svg>
          </i>
        </div>
  
        <div *ngxPermissionsOnly="['agent_dashboard_timeZone']" class="chips chips--with-divider"
          (click)="navService.toggleTimeZoneModal()" data-tooltip="Time Zones">
          <i class="fa-regular fa-earth-americas">
  
          </i>
        </div>
      </div>
      <!-- Right Drawer -->
      <!-- <div *ngIf="navService.isCenterLocation && (isQA || isSupervisor || isAdmin)" class="chips-container">
          <div class="chips chips--with-divider" [attr.data-tooltip]="_centerData?.centerViewTooltip"
            data-tooltip-conf="bottom">
            Center View : {{_centerData?.centerView}}
          </div>
        </div> -->
      <div
        *ngIf="(router.isActive('/supervisor/insight/dashboard', true) || router.isActive('/supervisor/insight/chat/dashboard', true)) && navService.isActiveTab(InsightsDashboardTab.Voice)"
        class="chips-container">
        <div class="chips chips--with-divider" (click)="navService.toggleRightDrawer()">
          <i class="fa-regular chips__icon fa-grip-vertical widget_icon"></i>
        </div>
      </div>
      <div *ngIf="navService.isCenterLocation && (isQA || isSupervisor || isAdmin)" class="chips-container">
        <div class="chips chips--with-divider" (click)="navService.toggleLocationDrawer()">
          <i class="fa-regular chips__icon fa-map-marker widget_icon"></i>
        </div>
      </div>
    </div>
  </div>
  
<!-- <app-incoming-call></app-incoming-call> -->

    <!-- <div class="caller-module-container">
      <div class="banner-wrapper">
        <div class="caller-module-horizental">
    
          <div class="user-avatar"> <i class="fa-thin fa-user-hair"></i></div>
    
          <div class="caller-module__info">
            <h2 class="caller-module__title">Inbound call</h2>
            <h3>Usama Ayoub</h3>
            <p>03337588013</p>
          </div>
    
    
    
          <div class="button-container">
            <div class="ring-wrapper">
    
              <div class="pulse-ring"></div>
    
    
              <button class="call-button" title="Accept Call">
                <i class="fa-thin fa-phone"></i>
              </button>
            </div>
          </div>
    
        </div>
      </div>
    
    </div> -->

    
</header>

<!-- <header class="mast-header mast-header--revised">
  <div class="menu menu-one">
    <ul class="menu-links">
      <li>
        <a  class="logo-link"
          ><img src="/assets/styles/assets/images/flecx-logo-new.svg" alt="fleCX-logo" class="logo"
        /></a>
      </li>
      <li><a [routerLink]="['/agent']"  class="active-link">Agent</a></li>
      <li><a [routerLink]="['/composer']" >Composer</a></li>
      <li>
        <a (click)="onLogout($event)" href="#">
          <i class="fa fa-sign-out"></i>
        </a>
      </li>
    </ul>
  </div>
  <div class="menu menu-three">
    <ul class="menu-links">
      <a >
        <ul class="user-status">
          <li>
            <div class="user-img"><img src="/assets/styles/assets/images/icons/profile-bitmoji.png" alt="agent-img" /></div>
          </li>
          <li>
            <p>Chad Rycenga</p>
            <span>On Break</span>
          </li>
          <li><i class="fa-thin fa-angle-down"></i></li>
        </ul>
      </a>
    </ul>
  </div>
</header> -->

<!-- Secondary Nav/Top/Bar/Action Bar -->
<!-- <section class="secondary-nav">
  <ul class="notification">
    <li>
      <i class="fa-thin fa-angle-left"></i>
      <p>1 / 3</p>
      <i class="fa-thin fa-angle-right"></i>
    </li>
    <li>
      <i class="fa-thin fa-bell"></i>
      <p>You have been assigned to a protocol level functionality...</p>
    </li>
  </ul>
</section> -->

<!-- <nav class="">
  <div class="container">
    <a [routerLink]="['/']" class="flex items-center">
      <img width="100" src="/assets/logo-white.svg" alt="Flecx Logo" />
    </a>
    <ul>
      <li class="mx-3">
        <a
          [routerLink]="['/agent']"
          href="#"
          class="block py-2 pr-4 pl-3 text-gray-700 rounded hover:bg-gray-100 md:hover:bg-transparent md:border-0 md:hover:text-blue-700 md:p-0 dark:text-gray-400 md:dark:hover:text-white dark:hover:bg-gray-700 dark:hover:text-white md:dark:hover:bg-transparent"
        >
          Agent
        </a>
      </li>
      <li class="mx-3">
        <a
          [routerLink]="['/supervisor']"
          href="#"
          class="block py-2 pr-4 pl-3 text-gray-700 rounded hover:bg-gray-100 md:hover:bg-transparent md:border-0 md:hover:text-blue-700 md:p-0 dark:text-gray-400 md:dark:hover:text-white dark:hover:bg-gray-700 dark:hover:text-white md:dark:hover:bg-transparent"
        >
          Supervisor
        </a>
      </li>
      <li class="mx-3">
        <a
          [routerLink]="['/admin']"
          href="#"
          class="block py-2 pr-4 pl-3 text-gray-700 rounded hover:bg-gray-100 md:hover:bg-transparent md:border-0 md:hover:text-blue-700 md:p-0 dark:text-gray-400 md:dark:hover:text-white dark:hover:bg-gray-700 dark:hover:text-white md:dark:hover:bg-transparent"
        >
          Admin
        </a>
      </li>
    </ul>
    <ul>
      <li>
        <a
          (click)="onLogout($event)"
          href="#"
          class="block py-2 pr-4 pl-3 text-gray-700 rounded hover:bg-gray-100 md:hover:bg-transparent md:border-0 md:hover:text-blue-700 md:p-0 dark:text-gray-400 md:dark:hover:text-white dark:hover:bg-gray-700 dark:hover:text-white md:dark:hover:bg-transparent"
        >
          <i class="fa fa-sign-out"></i>
        </a>
      </li>
    </ul>
  </div>
</nav> -->


